import { render, staticRenderFns } from "./form-admin.vue?vue&type=template&id=1a4dffe0&scoped=true"
import script from "./form-admin.vue?vue&type=script&lang=js"
export * from "./form-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4dffe0",
  null
  
)

export default component.exports